export default __webpack_public_path__ + "static/media/searchIcon.17135b9d.svg";